import { format } from "date-fns";
import api from "../services/api";

interface IProductivityResponse {
    codeResult: string;
    data: any[];
}

export interface IProductivityParams {
    dataInicial: string;
    dataFinal: string;

}
export interface IProductivityMonth {
    representante: string;
    quantidade: number;
}


class ProductivityRepository {
    public async PartialMonth({ dataInicial, dataFinal }: IProductivityParams): Promise<IProductivityMonth[]> {

        const body = {
            "tables": ["Kit", "Pedido", "Representante"],
            "sql": [
                {
                    "coderesult": "Produtividade",
                    "query": `SELECT Representante.nome as Representante, COUNT(Kit.id) as Qtd 
                    FROM Kit 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId 
                    INNER JOIN Representante 
                    ON Representante.id = Pedido.representanteId 
                    WHERE Kit.tipo = 0 
                    AND Kit.dataEntrega >= '${dataInicial}' 
                    AND Kit.dataEntrega < '${dataFinal}T23:59:59Z'
                    AND Kit.estado = 0 
                    AND Kit.statusKit = 3
                    GROUP BY Representante.nome 
                    ORDER BY Qtd DESC`
                }
            ]
        };

        const response = await api.post<IProductivityResponse[]>("reports", body);
        console.log(response);
        return this.GetFromCodeResult(response.data, "Produtividade").map(result => {
            return {
                representante: result.Representante,
                quantidade: result.Qtd
            }
        });
    }

    GetFromCodeResult(data: IProductivityResponse[], codeResult: string) {

        return data.find(result => result.codeResult === codeResult)?.data || [];
    }
}

const productivityRepository = new ProductivityRepository();
export default productivityRepository;